import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./SaveGuardPrompt.module.css";
import { Trans, useTranslation } from "@coworker/locales";

type SaveGuardPromptProps = {
  visible: boolean;
  onLeave: () => void;
  onStay: () => void;
};

export const SAVE_GUARD_PROMPT_DATA_TESTID = "SaveGuardPrompt";

function SaveGuardPrompt({ visible, onLeave, onStay }: SaveGuardPromptProps) {
  const { t } = useTranslation();

  return (
    <FixaModal
      visible={visible}
      handleCloseBtn={onStay}
      data-testid="SaveGuardPrompt"
    >
      <FixaPrompt
        className={styles["prompt"]}
        title={t("youHaveUnsavedChanges")}
        titleId="UnsavedChangesPrompt-title"
        header={
          <FixaModalHeader
            closeBtnClick={onStay}
            className={styles["header"]}
          />
        }
        footer={
          <FixaModalFooter stacked>
            <FixaButton text={t("leaveWithoutSaving")} onClick={onLeave} />
            <FixaButton
              text={t("stayOnPage")}
              onClick={onStay}
              type="primary"
            />
          </FixaModalFooter>
        }
      >
        <FixaText textStyle="Body.M">
          <Trans>ifYouLeaveNow</Trans>
          <br />
          <Trans>areYouSureYouWantToLeave</Trans>
        </FixaText>
      </FixaPrompt>
    </FixaModal>
  );
}

export default SaveGuardPrompt;
